module.exports = __webpack_public_path__ + "static/media/arrow-right.492bf684.svg";